module.exports = __webpack_public_path__ + "img/04-full.c58223e1.jpg";